import { Route, Routes } from 'react-router-dom'
import GiftCardHome from './home'
import GiftCardClaim from './gift-card-claim'

const GiftCard = () => {
  return (
    <Routes>
      <Route index element={<GiftCardHome />} />
      <Route path="/claim" element={<GiftCardClaim />} />
    </Routes>
  )
}
export default GiftCard
